export default __webpack_public_path__ + "static/media/close-icon.b66c7ce9.svg";